interface ErrorFallbackProps {
  onReset: () => void;
}

function ErrorFallback({ onReset }: ErrorFallbackProps) {
  return (
    <div role="alert" style={{ padding: "2rem", textAlign: "center" }}>
      <h1>Something went wrong</h1>
      <p>An unexpected error occurred. Please try again.</p>
      <button onClick={onReset}>Try again</button>
    </div>
  );
}

export default ErrorFallback;
